var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statusbar"},[_c('portal-target',{attrs:{"name":"status-bar"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }